<template>
  <div class="arrears-statistics">
    <div class="searchbox order_searchbox">
      <form action="#" method="get" class="form-inline form-float" @submit.prevent>
        <div class="form-group">
          <label for>车牌号:</label>
          <input
            v-model="search.carNumber"
            class="form-control"
            type="text"
            size="12"
          />
        </div>
        <div class="form-group">
          <label for="bdate">统计时间区间:</label>
          <el-date-picker
            clearable
            v-model="search.entryDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </div>
        <div class="form-group">
          <label for>联系手机:</label>
          <input
            v-model="search.phone"
            class="form-control"
            type="text"
            size="12"
          />
        </div>

        <div class="form-group others">
          <span class="search_btn">
            <el-button
              @click="searchList"
              type="button"
              class="btn btn-primary"
              id="search_btn"
              :loading="loading"
              size="small"
            >
              查询
            </el-button>
          </span>
          <span class="download_btn">
            <el-button
              :loading="downloading"
              type="primary"
              size="small"
              @click="downloadExcel"
              >导出EXCEL</el-button
            >
          </span>
        </div>
      </form>
    </div>
    <div style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;padding:20px;font-size:16px;font-weight:bold">
      <div><span style='color:#999;display:inline-block;padding-right:10px'>公务用车欠费: </span><span style='font-size:20px'>¥{{ unpayClassifyStatisticsData.officeArrears }}</span></div>
      <div><span style='color:#999;display:inline-block;padding-right:10px'>工程用车欠费: </span><span style='font-size:20px'>¥{{ unpayClassifyStatisticsData.engineeringArrears }}</span></div>
      <div><span style='color:#999;display:inline-block;padding-right:10px'>外地车牌欠费: </span><span style='font-size:20px'> ¥{{ unpayClassifyStatisticsData.nonlocalArrears }}</span></div>
      <div><span style='color:#999;display:inline-block;padding-right:10px'>无牌车牌含无登记: </span><span style='font-size:20px'>{{ unpayClassifyStatisticsData.nonRegister }}</span></div>
    </div>
    <div class="list-right">
      <el-table
        v-loading="loading"
        ref="table"
        border
        :data="tableListData.rows"
        height="100%"
        width="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        @selection-change="onSelectionChange"
      >
        <el-table-column
          show-overflow-tooltip
          width="150px"
          label="车牌号"
          prop="carNumber"
        >
        </el-table-column>
        <el-table-column
          width="150px"
          label="统计时间"
          prop="beginRegion"
        ></el-table-column>
        <el-table-column
          width="150px"
          label="联系方式"
          prop="phone"
        ></el-table-column>

        <el-table-column
          width="150px"
          label="当前欠费次数"
          prop="totalUnpayCount"
        >
          <template slot-scope="scope">
            <span class="total-unpay-count" @click="goToDetail(scope.row)">{{
              scope.row.totalUnpayCount
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          label="当前欠费金额"
          prop="totalArrearsMoney"
        >
          <template slot="header" slot-scope="scope">
            <el-popover
              class="arrears-statistics-popover"
              v-model="visible"
              placement="bottom"
              width="200"
            >
              <div class="arrears-money">
                <div class="arrears-money-search">
                  <input
                    v-model="arrearSearch.minArrearsMoney"
                    type="number"
                    size="12"
                  />-
                  <input
                    v-model="arrearSearch.maxArrearsMoney"
                    type="number"
                    size="12"
                  />
                  <div class="arrears-money-btns">
                    <button
                      @click="onArrearsMoneySearchSure"
                      class="arrears-money-sure-btn"
                    >
                      确认
                    </button>
                    <button
                      @click="visible = false"
                      class="arrears-money-cancel-btn"
                    >
                      取消
                    </button>
                  </div>
                </div>
              </div>
              <div slot="reference">
                <span>当前欠费金额</span>
                <img
                  class="arrears-money-search-icon"
                  src="../../../../assets/images/search.png"
                />
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="欠费逾期最长天数"
          prop="maxUpayDays"
        ></el-table-column>

        <el-table-column show-overflow-tooltip label="操作" width="250px">
          <template slot-scope="scope">
            <button type="button" class="reclaim-btn" disabled>
              追缴
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Page
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    ></Page>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

import {
  roadsideArrearsStatistics,
  reqVerifyEtc,
  reqEtcPay,
  batchCancelOrders,
  unpayClassifyStatistics
} from "@/api/url";

import Page from "@/page/commons/page";
import { MessageBox } from "element-ui";
import dayjs from "dayjs";
export default {
  data() {
    return {
      visible: false,
      loading: false,
      dropdownVisible: false,
      arrearSearch: {
        minArrearsMoney: "",
        maxArrearsMoney: "",
      },
      styleObj: {
        "text-align": "center",
      },

      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      photoDialogVisible: false,
      photoY: false,
      photoN: false,
      photoShow: false,
      imgList: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        carNumber: "",
        entryDate: [dayjs(), dayjs()],
        phone: "",
      },
      tableListData: {},
      unpayClassifyStatisticsData:{
        officeArrears: 0,
        engineeringArrears: 0,
        nonlocalArrears: 0,
        nonRegister: 0
      },
      pageObj: {},
      selectedList: [],
      totalMap: {},
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = dayjs();
              const start = dayjs();

              picker.$emit("pick", [end, start]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = dayjs().startOf("week");
              const start = dayjs()
                .endOf("week")
                .subtract(1, "millisecond");

              picker.$emit("pick", [end, start]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const end = dayjs().startOf("month");
              const start = dayjs()
                .endOf("month")
                .subtract(1, "millisecond");

              picker.$emit("pick", [end, start]);
            },
          },
          {
            text: "本年",
            onClick(picker) {
              // 获取当前年份
              const currentYear = dayjs().year();
              const end = dayjs(`${currentYear}-01-01`);
              const start = dayjs(`${currentYear}-12-31`).endOf("day");
              picker.$emit("pick", [end, start]);
            },
          },
        ],
      },
      downloading: false,
    };
  },
  components: {
    Page,
  },

  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    onSelectionChange(val) {
      this.selectedList = [...val];
    },
    executeBatchEliminate() {
      if (this.selectedList?.length <= 0) {
        this.$message({
          type: "warning",
          message: "请选择要冲销的订单",
        });
        return;
      }

      if (
        this.selectedList.some(({ orderStatus }) => orderStatus == "已取消")
      ) {
        this.$message({
          type: "warning",
          message: `选择的订单为“已取消”`,
        });
        return;
      }
      MessageBox.confirm(
        `此操作将冲销订单号为${this.selectedList
          ?.map(({ order_id }) => order_id)
          ?.join(",") ?? ""}的订单, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          return this.$postRequest(
            batchCancelOrders(),
            this.selectedList?.map(({ order_id }) => order_id)
          );
        })
        .then((data) => {
          if (data?.status == 200) {
            this.$message({
              type: "success",
              message: "批量冲销成功!",
            });
            this.tableList(this.pageObj.curIndex);
            this.selectedList = [];
          }
        })
        .catch((error) => {
          this.$message({
            type: "info",
            message: error,
          });
        });
    },
    handleSearchData() {
      const { carNumber, entryDate, phone } = this.search;
      const { minArrearsMoney, maxArrearsMoney } = this.arrearSearch;
      let params = {};
      if (carNumber) {
        params = { ...params, carNumber };
      }
      if (phone) {
        params = { ...params, phone };
      }
      if (minArrearsMoney || String(minArrearsMoney) === "0") {
        params = { ...params, minArrearsMoney };
      }
      if (maxArrearsMoney || String(maxArrearsMoney) === "0") {
        params = { ...params, maxArrearsMoney };
      }
      if (entryDate?.length > 0) {
        params = {
          ...params,
          crtTime:
            this.search.entryDate == ""
              ? ""
              : JSON.stringify(
                  this.search.entryDate.map((date) => this.formatDate(date))
                ),
        };
      }
      return params;
    },
    getUnpayClassifyStatistics:function(){
      this.$get(unpayClassifyStatistics(),{
        ...this.handleSearchData(),
      }).then((data)=>{
      this.unpayClassifyStatisticsData = data?.data ?? {
        officeArrears: 0,
        engineeringArrears: 0,
        nonlocalArrears: 0,
        nonRegister: 0
      };
      });
      
    },
    tableList: function(curPage) {
      var _this = this;
      this.loading = true;
      let params = {
        ...this.handleSearchData(),
        limit: this.search.pageSize,
        page: curPage,
      };

      this.$get(roadsideArrearsStatistics(), {
        ...params,
      })
        .then((data) => {
          if (data.status != 200) return;
          //翻页
          var rows = data.data.rows;
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.pageObj = { ...pageObj };
          // _this.getPage(pageObj);
          _this.tableListData = {
            ...data?.data,
            rows: data?.data?.rows ?? {},
          };
          _this.totalMap = data?.data?.totalMap ?? {};
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchList: function() {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
      this.getUnpayClassifyStatistics();
    },

    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.type = "";
      this.search.startTime = "";
      this.search.endTime = "";
    },
    showPhoto(url) {
      this.photoDialogVisible = true;
      const urls = url?.split(",") ?? [];

      this.$refs.imgDialog.style.height = "100vh";
      this.$refs.imgDialog.style.width = "100vw";
      this.$refs.imgDialog.style.background = "rgba(0,0,0,0.5)";
      this.$refs.imgDialog.style.position = "fixed";
      this.$refs.imgDialog.style.top = 0 + "px";
      this.$refs.imgDialog.style.left = 0 + "px";

      if (urls.length <= 0) {
        this.photoY = false;
        this.photoN = true;
      } else {
        this.photoY = true;
        this.photoN = false;

        this.$refs.img1.src = urls[0];
        this.$refs.img2.src = urls[1];
      }

      // this.imgDialog.url = url;
      this.$refs.show.open();
      // console.log(img)
      // ctx.drawImage(img,0,0);
      // window.open(url,'_blank');

      // this.imgViewerVisible = true;
      // this.imgList = url.split(",");
      // const m = (e) => {
      //   e.preventDefault();
      // };
      // document.body.style.overflow = "hidden";
      // document.addEventListener("touchmove", m, false); //禁止页面滑动
    },
    hiddenShade() {
      this.$refs.imgDialog.style.height = 0 + "px";
      this.$refs.imgDialog.style.width = 0 + "px";
    },
    showImg() {
      // console.log("6666")
    },
    onVerityEtcBtn(arrear) {
      const { pla_id } = arrear;

      this.$get(reqVerifyEtc(), { plaId: pla_id })
        .then((data) => {
          this.tableList(this.search.pageNumber);
          if (data.status === 200) {
            this.$message({
              type: "success",
              message: "验证成功",
            });

            return;
          }
          if (data.status !== 200) {
            this.$message({
              type: "warning",
              message: data.message,
            });
            return;
          }
        })
        .catch((err) => {
          this.$message({
            type: "warning",
            message: err,
          });
        });
    },
    onEtcPayBtn(arrear) {
      const { order_id } = arrear;
      this.$get(reqEtcPay(), { order_id })
        .then((data) => {
          if (data.status === 200) {
            this.$message({
              type: "success",
              message: "ETC扣款成功",
            });
            this.tableList(this.search.pageNumber);
            return;
          }
          if (data.status !== 200) {
            this.$message({
              type: "warning",
              message: data.message,
            });
            return;
          }
        })
        .catch((err) => {
          this.$message({
            type: "warning",
            message: err,
          });
        });
    },
    downloadExcel() {
      let params = this.handleSearchData();
      this.downloading = true;
      this.$downloadFileRequest(
        "/api/parking/parkingOrders/queryUnpayOrderStatisticsExport",
        { ...params },
        "欠费统计"
      ).finally(() => (this.downloading = false));
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "总计";
        }

        if (index === 9) {
          sums[index] = this.totalMap?.arrearsMoneyTotal ?? 0;
        }
      });
      return sums;
    },
    formatDate(date) {
      return dayjs(date).format("YYYY-MM-DD");
    },
    goToDetail(row) {
      this.$router.push({
        path: "/main/recovery-rules/arrears-list",
        query: { carNumber: row.carNumber, crtTime: row.beginRegion },
      });
    },

    onArrearsMoneySearchSure() {
      this.visible = false;
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
  },

  computed: {},

  created: function() {},
  mounted: function() {
    this.search.pageNumber = 1;
    this.tableList(this.search.pageNumber);
    this.getUnpayClassifyStatistics();
  },
  watch: {},
};
</script>
<style scoped>
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.searchbox {
  background: #f9f9fb;
  /* height:130px;
            line-height:45px; */
  border-bottom: 10px solid #eff2f7;
  /* height:150px; */
  padding: 10px 10px 0 10px;
}

.refresh {
  display: inline-block;
}

.bread_container {
  display: inline-block !important;
  border: none !important;
  padding: 0 !important;
}

/* .photo{
            width:60px;
            font-size:12px;
            background:#409EFF;
            color:white;
            height:20px;
            line-height:20px;
            
        } */
.imgDialog {
  overflow: hidden;
}
button.photo {
  height: 22px;
  line-height: 22px;
  color: #278cd8;
  background: none;
  font-size: 12px;
  margin-right: 5px;
}

.photoN {
  width: 350px;
  line-height: 300px;
  height: 300px;
  text-align: center;
  display: inline-block;
}

.imgDialog {
  animation: opacity2 3s;
  -webkit-animation: opacity2 3s;
  -moz-animation: opacity2 3s;
}

@keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

button.gray {
  color: gray;
}
.form-group {
  margin-bottom: 10px;
}
.gap {
  margin-right: 5px;
}
.arrears-statistics .list-right {
  height: calc(100vh - 190px);
}
</style>
<style>
.arrears-statistics .el-date-editor.el-input,
.arrears-statistics .el-date-editor.el-input__inner {
  max-width: 100% !important;
}

.arrears-statistics .el-date-editor .el-range-input {
  font-size: 12px !important;
}

.arrears-statistics .el-date-editor .el-range-separator {
  font-size: 12px !important;
}

.arrears-statistics .imgDialog .el-dialog__header {
  display: none;
  padding: 0;
}

.arrears-statistics .imgDialog .el-dialog__body {
  padding: 0 !important;
}

.arrears-statistics .imgDialog .el-dialog__footer {
  padding: 0 !important;
}

.arrears-statistics .searchbox .el-select {
  width: 150px !important;
}

.arrears-statistics .order_searchbox .form-control {
  width: 150px;
}
.arrears-statistics .order_searchbox form {
  height: auto;
}

.arrears-statistics .el-dialog {
  margin-top: 10vh !important;
}

/* .el-dropdown-link {
         display: inline-block;;
        cursor: pointer;
        color:white;
        background:#278cd8;
        height:34px;
        border-radius: 5px;
        padding-left:5px;
        font-size: 12px;
        line-height:37px;
        width:90px;
      } */
.arrears-statistics .el-icon-arrow-down {
  font-size: 12px;
}

.arrears-statistics .dowload {
  padding-left: 10px;
  display: inline-block;
}

.arrears-statistics .img-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 0 20px 20px;
}

.arrears-statistics img {
  overflow: hidden;
}

.arrears-statistics .img-container img {
  box-sizing: border-box;
  padding-right: 20px;
}

.arrears-statistics .searchbox .form-inline {
  overflow: auto;
}
.arrears-statistics .is-gray {
  color: #666;
  cursor: not-allowed;
}
/* .arrears-money{
    position: relative;
} */
.arrears-money-search {
  /* padding: 10px; */
  /* 
  border: 1px solid #eee; */

  /* 
  width: 200px; */

  /* border-radius: 10px;
  box-shadow: 0 0 10px 5px #eee;
  border-top: none; */
}
.arrears-money-search input {
  width: 80px;
  border: 1px solid #ddd;
  height: 30px;
  border-radius: 4px;
  text-align: center;
}
.arrears-money-btns button {
  height: 20px;
  line-height: 20px;
  margin-right: 10px;
  letter-spacing: 2px;
  text-align: center;
  padding: 0 10px;
}
.arrears-money-sure-btn {
  background: #278cd8;
  color: white;
}
.arrears-money-search-icon {
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.total-unpay-count {
  cursor: pointer;
  border-bottom: 1px solid #278cd8;
}
.reclaim-btn {
  background: none;
  cursor: not-allowed !important;
}
</style>
<style>
.arrears-statistics .modify-plate .el-input__inner {
  height: 40px;
}
.arrears-statistics .modify-plate .el-select {
  width: 100%;
}
.arrears-statistics .el-table {
  position: relative;
}
.arrears-statistics .el-table th > .cell {
  position: static;
}
.arrears-statistics .el-table td,
.el-table th {
  position: static;
}

.el-popover {
  z-index: 1000000 !important;
}
.arrears-money-btns {
  margin: 10px 0 0 0;
  display: flex;
  justify-content: flex-end;
}
.arrears-money-btns button.arrears-money-cancel-btn {
  margin-right: 0;
}
</style>
